import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  AR_CONTENT_TAB,
  RESOURCE_APPLICATION_TAB,
  RESOURCE_ENVIRONMENT_TAB,
  RESOURCE_MODULE_TAB,
  RESOURCE_SKILL_SCHOOL_TAB,
  RESOURCE_SKILL_STREAM_TAB,
} from "../../constant/constants";
import { toggleArrayByObject } from "../../utils/general";
import FilterTab from "./FilterTab";

const body = document.body;

const ResourceFilter = ({ showfilter, openFilter, activeTab, checkedFilterItem, setCheckedFilterItem }) => {
  const filterOptionsData = useSelector((state) => state.filterOptions);
  const [filterCategoryOption, setFilterCategoryOption] = useState({
    [RESOURCE_APPLICATION_TAB]: [],
    [RESOURCE_MODULE_TAB]: [],
    [RESOURCE_ENVIRONMENT_TAB]: [],
    [RESOURCE_SKILL_STREAM_TAB]: [],
    [RESOURCE_SKILL_SCHOOL_TAB]: [],
    [AR_CONTENT_TAB]: [],
  });

  useEffect(() => {
    if (!showfilter) {
      body.classList.add("filter-active");
    } else {
      body.classList.remove("filter-active");
    }
  }, [showfilter]);

  useEffect(() => {
    let appCategory = filterOptionsData?.filter[RESOURCE_APPLICATION_TAB]?.tags || [];
    let applicationFilterOptions = [
      {
        name: "Category",
        tags: appCategory.map((tag) => ({
          name: tag.name,
          key: tag.id,
          value: tag.id,
          id: tag.id,
          type: "Category".replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase(),
        })),
      },
    ];

    let resourceFilterOption = filterOptionsData?.filter[RESOURCE_MODULE_TAB]?.children?.map((category) => ({
      name: category.name,
      tags: category.tags.map((tag) => ({
        name: tag.name,
        key: tag.id,
        value: tag.id,
        id: tag.id,
        type: category.name.replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase(),
      })),
    }));

    let environmentFilterOption = filterOptionsData?.filter[RESOURCE_ENVIRONMENT_TAB]?.children?.map((category) => ({
      name: category.name,
      tags: category.tags.map((tag) => ({
        name: tag.name,
        key: tag.id,
        value: tag.id,
        id: tag.id,
        type: category.name.replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase(),
      })),
    }));

    let skillStreamFilterOptions = filterOptionsData?.filter[RESOURCE_SKILL_STREAM_TAB]?.children?.map((category) => ({
      name: category.name,
      tags: category.tags.map((tag) => ({
        name: tag.name,
        key: tag.id,
        value: tag.id,
        id: tag.id,
        type: category.name.replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase(),
      })),
    }));

    setFilterCategoryOption((pre) => ({
      ...pre,
      [RESOURCE_APPLICATION_TAB]: applicationFilterOptions,
      [RESOURCE_MODULE_TAB]: resourceFilterOption,
      [RESOURCE_SKILL_SCHOOL_TAB]: resourceFilterOption,
      [RESOURCE_ENVIRONMENT_TAB]: environmentFilterOption,
      [RESOURCE_SKILL_STREAM_TAB]: skillStreamFilterOptions,
      [AR_CONTENT_TAB]: [],
    }));

  }, [filterOptionsData]);


  const handleClickSelectCheckbox = (data, isCategory = false) => {
    setCheckedFilterItem((pre) => {
      const items = pre[activeTab];
      const [categories, tags] = [items.filter((e) => e.type === "tagCategory"), items.filter((e) => e.type !== "tagCategory")];
      const updated = isCategory ? [...tags, ...data] : [...toggleArrayByObject(tags, data), ...categories];
      return { ...pre, [activeTab]: updated };
    });
  };

  const handleResetCheckBox = () => {
    setCheckedFilterItem((pre) => ({
      ...pre,
      [activeTab]: [],
    }));
  };

  return (
    <div>
      <FilterTab
        showfilter={showfilter}
        selectedCheckboxes={checkedFilterItem[activeTab]}
        setSelectedCheckboxes={handleClickSelectCheckbox}
        filterOptions={filterCategoryOption[activeTab]}
        onToggleFilter={() => openFilter(null)}
        handleResetCheckBox={handleResetCheckBox}
        categoryOptions={activeTab === RESOURCE_MODULE_TAB ? filterOptionsData?.filter.CATEGORY_TAB_FILTER || null : null}
      />
    </div>
  );
};

export default ResourceFilter;
